<template>
  <div class="home__main">
    <div :class="{open: isLoading}" class="loading">
      <div class="nb-spinner" />
    </div>
    <div class="home__header">
      <div class="container__fluid">
        <div class="logo">
          <a href="#">
            <img src="/assets/images/logo.svg" alt="logo">
          </a>
        </div>
        <div class="connect-wallet">
          <el-select
            v-model="chainId"
            class="header-select"
            placeholder="Chain"
            no-data-text="Empty"
            value-key="name"
            @change="handleChange"
          >
            <el-option
              v-for="item in listChain"
              :key="item.chainId"
              :label="`${item.name}`"
              :value="item"
            />
          </el-select>
          <el-button v-if="!isConnectWallet || isDisconnect" type="text" class="home__btn" @click="connectWallet">
            Connect Wallet
          </el-button>
          <div v-else class="balance">
            <div class="value">
              {{ balance }} {{ chainId?.name }}
            </div>
            <el-dropdown>
              <el-button type="primary" class="home__btn dropdown">
                {{ formatWallet(addressWallet) }}<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="disconnect">
                  Disconnect
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="container__fluid">
      <div class="home__form">
        <h1 class="home__form-title">
          U2U Faucet
        </h1>
        <p class="home__form-text">
          Get your U2U for development and testing.
        </p>
        <div class="home__form-content">
          <input
            v-model="addressData"
            type="text"
            placeholder="Enter Your U2U Address..."
            class="home__form-input"
            autocomplete="off"
          >
          <el-select v-model="tokenId" class="home__form-select" placeholder="Select" no-data-text="Empty">
            <el-option
              v-for="item in tokens"
              :key="item.id"
              :label="`${item.name} (${item.amount})`"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="center">
          <vue-recaptcha
            class="recaptcha"
            :style="{ margin: '0 auto' }"
            :sitekey="v2Key"
            @verify="verifyMethod"
            @expired="expiredMethod"
            @error="errorMethod"
          />
        </div>
        <el-button type="text" class="home__form-btn" :class="{'disabled': !recapchaToken || !addressData}" @click="send">
          FAUCET
        </el-button>
        <div
          :class="{show: isShow}"
          class="link"
        >
          <i class="fa-light fa-hand-point-right" />
          <a :href="linkURL" target="_blank">
            Click here to view on Block Explorer</a>
        </div>
      </div>
      <div class="home__collapse">
        <h2 class="home__collapse-title">
          FAQs
        </h2>
        <el-collapse v-for="(item, index) in listFAQs" :key="index" v-model="activeNames">
          <el-collapse-item :title="item.question" :name="item.nameNumber">
            <div>{{ item.answer.replace('delayFaucetTime', hour + 'h' ) }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>

import httpClient from '../http/http-client.js'
import { providers } from "ethers";
// import WalletConnectProvider from '@walletconnect/web3-provider';
// import {EthereumProvider} from "@walletconnect/ethereum-provider";
import { formatEther } from '@ethersproject/units';
const U2U_FAUCET = 'u2u_faucet'
import { VueRecaptcha } from 'vue-recaptcha'
import { wc_connect } from '../wallet-connect/w2.js'

export default {
  name: 'HomePage',
  components: {VueRecaptcha},
  data () {
    return {
      v2Key: process.env.VUE_APP_RECAPTCHA_KEY,
      recapchaToken: '',
      isLoading: false,
      chanId: '',
      activeNames: ['1'],
      addressData: '',
      linkURL: '',
      isShow: false,
      hour: 0,
      tokens: [],
      listFAQs: [
        {
          question: "How do I use this?",
          answer: `To request funds, simply enter your wallet address and hit 
          “FAUCET”. We support wallets as received addresses but not 
          smart contracts.`,
          nameNumber: "1"
        },
        {
          question: "How does it work?",
          answer: `You can request 1 U2U every delayFaucetTime without any authentication.`,
          nameNumber: "2"
        },
        {
          question: "What is a testnet UniUltra Coin faucet?",
          answer: `An U2U faucet is a developer tool to get testnet UniUltra Coin 
          (U2U) in order to test and troubleshoot your decentralized application 
          or protocol before going live on U2U mainnet, where one must use real 
          U2U. Most faucets require social authentication (e.g. Twitter post or 
          login confirming you are a real human) or place you in a queue to wait 
          for a testnet token through the faucet. `,
          nameNumber: "3"
        },
        {
          question: "What is a testnet token?",
          answer: `Testnet tokens are a test currency that allows you to test 
          your UniUltra application before going live on mainnet. Testnet 
          tokens can be used in place of mainnet U2U tokens on testnets 
          like U2U. You can read more here.`,
          nameNumber: "4"
        },
      ],
      isConnectWallet: false,
      addressWallet: '',
      isDisconnect: false,
      chainId: null,
      chainNumberId: 2484,
      userCloseModal: false,
      provider: null,
			balance: null,
      tokenId: null,
      listChain: [],
      explorerUrl: process.env.VUE_APP_EXPLORER_URL,
    };
  },

  created () {
    this.handleInit()
    // this.getToken()
    const domain = window.location.origin
    if (domain === 'https://faucet.uniultra.xyz') {
      window.location.href = 'https://faucet.u2u.xyz'
    }
  },
  methods: {
    async handleInit () {
      this.getConfig()
      await this.getListChain()
      this.handleSwitchNetwork(this.chainNumberId)
      const data = this.getLocalStorage()
      if(data) {
        this.isDisconnect = data?.isDisconnect
      }
      this.getAccountConnect()
    },
    handleChange (item) {
      const {chainId, chainNumberId} = item
      this.chainNumberId = chainNumberId
      if(this.isConnectWallet) {
        this.connectWallet()
      }
      chainId && this.getToken(chainId)
    },
    async getListChain () {
      const response = await httpClient.get(`${process.env.VUE_APP_API_FAUCET}/chain?chainId=u2u`)
      if(response.data.status) {
        this.chainId = response.data.data[0]
        this.chainNumberId = response.data.data[0].chainNumberId
        this.getToken(this.chainId.chainId)
        this.listChain = response.data.data
      }
    },
    getExplorerUrl (chainId) {
      httpClient.get(`${process.env.VUE_APP_API_FAUCET}/chain/explore-url?chainId=${chainId}`).then((rs) => {
        if(rs.data.data?.testnet) {
          this.explorerUrl = rs.data.data?.testnet
        }
      })
    },
    async getToken (chainId) {
      this.getExplorerUrl(chainId)
			const response = await httpClient.get(`${process.env.VUE_APP_API_FAUCET}/token-faucet?chainId=${chainId}`)
      this.tokens = response.data.data
      this.tokenId = this.tokens[0].id
		},
		async getConfig () {
			const response = await httpClient.get(`${process.env.VUE_APP_API_FAUCET}/faucet/config`)
			this.hour = (response.data.data.delayFaucetTime / 60) / 60
		},
    getLocalStorage () {
			const dataStr = localStorage.getItem(U2U_FAUCET)
			if(dataStr) {
			return JSON.parse(dataStr)
			}
			return null
    },
    setLocalStorage (key, value) {
      let _data = this.getLocalStorage()
      if(!_data) {
        _data = {}
      }
      localStorage.setItem(U2U_FAUCET, JSON.stringify({
        ..._data,
        [key]: value
      }))
    },
    errorMethod () {
      this.recapchaToken = ''
    },
    expiredMethod () {
      this.recapchaToken = ''
    },
    verifyMethod (token) {
      this.recapchaToken = token
    },
    async fetchBalance () {
      const web3Provider = new providers.Web3Provider(this.provider);
        const signer = await web3Provider.getSigner();
        const address = await signer.getAddress();
      const balance = await web3Provider.getBalance(
					address,
					"latest"
				)
				this.balance = this.formatPrice(formatEther(balance.toString()))
    },
    async faucet () {
      try {
        this.isLoading = true
          this.isShow = false
          const bodyObj = { 'address': this.addressData, tokenId: this.tokenId, 'recaptchaToken': this.recapchaToken }
          const response = await httpClient.post(`${process.env.VUE_APP_API_FAUCET}/faucet`, bodyObj)
          this.isLoading = false
          this.linkURL = `${this.explorerUrl}${response.data.data}`
          if (response.data.status === true) {
            this.success();
            this.isShow = true
            setTimeout(() => {
              this.fetchBalance()
            }, 2000)
          } else {
            this.error(response.data.message)
          }
      } catch (e) {
        this.isLoading = false
        this.error()
      }
    },
    error (message) {
      this.$notify.error({
        title: 'Error',
        message: message || 'Something went wrong',
        offset: 10,
      });
    },
    success () {
      this.$notify.success({
        title: 'Success',
        dangerouslyUseHTMLString: true,
        message: 'Transaction Success',
        offset: 10,
      });
    },
    send () {
      if(!this.recapchaToken || !this.addressData) {
        this.error(`Please enter Your ${process.env.VUE_APP_CHAIN_NAME} Address`)
      } else {
        this.faucet()
      }
    },
		formatWallet (str) {
      if (str?.length > 20) {
        return str.substr(0, 6) + '...' + str.substr(str.length - 3, str.length)
      }
      return str || ''
    },
    async disconnect () {
      if(this.provider.disconnect) {
        await this.provider.disconnect()
      }
      this.isDisconnect = true
      this.isConnectWallet = false
      if(this.addressData === this.addressWallet) {
        this.addressData = ''
      }
      this.setLocalStorage('isDisconnect', true)
    },
    updateAccountStatus (account) {
      this.addressData = account
      this.addressWallet = account
      this.isConnectWallet = true
    },
    async getAccountConnect () {
      let data = localStorage.getItem('u2u_faucet')
			if(data) {
        data = JSON.parse(data)
        if(data?.isConnected && !data.isDisconnect)
				this.connectWallet()
			}
    },
    decimalToHex (d) {
      let hex = Number(d).toString(16)
      hex = `0x${hex}`
      return hex
    },
    async handleSwitchNetwork (chainId) {
    try {
      if(window.ethereum) {
      await window.ethereum
        .request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: this.decimalToHex(chainId) }]
        }).then(() => {})
        .catch((ex) => {
          if (ex.data?.originalError?.code === 4902 && chainId === 2484) {
              const infoChain = {
                chainName: 'U2U Nebulas',
                chainId: this.decimalToHex(2484),
                nativeCurrency: { name: 'U2U', decimals: 18, symbol: 'U2U' },
                rpcUrls: ['https://rpc-nebulas-testnet.uniultra.xyz']
              }
              window.ethereum
                .request({
                  method: 'wallet_addEthereumChain',
                  params: [infoChain]
                })
            }
        })
      }
      }catch(ex) {
        console.error(ex)
      }
    },
    async connectWallet () {
			try {
        let web3Provider, signer, address, provider, balance
        const _chainId = this.chainNumberId
        if(window.ethereum) {
          await this.handleSwitchNetwork(_chainId)
          web3Provider = new providers.Web3Provider(window.ethereum);
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts', params: [] })
          if(accounts?.length > 0) {
            provider = window.ethereum
            this.provider = provider
            signer = await web3Provider.getSigner();
            address = await signer.getAddress();

          }
        } else {
          const localChain = localStorage.getItem('wc@2:ethereum_provider:/chainId')
          provider = await wc_connect(localChain || _chainId)
          this.provider = provider
          await provider.enable()
          web3Provider = new providers.Web3Provider(provider);
          signer = await web3Provider.getSigner();
          address = await signer.getAddress();

        }
        try {
          balance = await web3Provider.getBalance(
            address,
            "latest"
          )
        }catch(ex) {
          balance = 0
        }
        this.updateAccountStatus(address)
        this.isDisconnect = false
       await provider.request({ method: "eth_chainId" })
        this.setLocalStorage('isConnected', true)
        this.setLocalStorage('isDisconnect', false)
				this.balance = this.formatPrice(formatEther(balance.toString()))
        provider.on("disconnect", async () => {
          await provider.disconnect();
          this.isDisconnect = true
          this.isConnectWallet = false
          this.addressData = ''
          this.setLocalStorage('isConnected', false)
        });
        provider.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          this.addressData = accounts[0];
        }
        });
        provider.on("chainChanged", () => {
        // this.chainId = chainId
        });
			} catch(ex) {
				console.error(ex)
			}
		},
		formatPrice (price) {
			if(price <= 0) return 0
			if(price) {
				let _price = Math.round(price * 1e5) / 1e5
				if (price > 0 && _price === 0) {
					_price = price
				}
				return _price
			}
			return price
		}
  },
}
</script>
